'use strict'

import apiBaseUrl from "./apiBaseUrl";

const urlBase = apiBaseUrl(window.location.origin);

export const ReportService = {
    get: (number, unit, accessToken) => {
        const baseUrl = urlBase + "/report";
        const url = `${baseUrl}/past/${number}/${unit}`;
        const options = {
            method: 'GET',
            headers: {
                'Content-Type': "application/json",'Accept': "application/json",
                'Authorization': accessToken
            }
        };
        return fetch(url, options)
            .then(response => {
                if(response.status == 401) {
                    // window.location = '/';
                    window.location = '/dashboard?token=1';
                }
                return response.json();
            }).catch(error => {
                return error;
            });
    }
};


// WEBPACK FOOTER //
// ./src/service/reportService.js